import { signOut } from "aws-amplify/auth";
import ls from "@/utils/SecureLS";
import { toast } from "sonner";
import { clearUser } from "@/store/slices/authSlice";
import { useAppDispatch } from "@/store/hooks";
const useSignOut = (redirect = true) => {
  const dispatch = useAppDispatch();

  const handleSignOut = async () => {
    try {
      localStorage.clear();
      ls.clear();

      await signOut();
      dispatch(clearUser());
      

      if(redirect) {
        window.location.replace("/login")
      }
    } catch (error: any) {
      toast.error("Error signing out", {
        description: error?.message || "An error occurred. Please try again.",
      });
    }
  };

  return { handleSignOut };
};
export default useSignOut;
